//----- Component --------------------------------------------------------/

// Developer : Daiana Curcio / Nicolas Pascucci

// Creation Date : 3/1/2024

// Version : 1

// Description : Historial de conversión con importación a CSV
//

//------Changes --------------------------------------------------------------------- -------------//

// Change Date :

// Change by :

// Change description:

//

// Change Date :

// Change by :

// Change description:

//
//========================================================================/

import React, { useState, useEffect, useMemo } from "react";
import { UrlApi } from "../../services/apirest";
import MaterialReactTable, {
  MRT_FullScreenToggleButton,
} from "material-react-table";
import { MRT_Localization_ES } from "material-react-table/locales/es"; //Tabla en español
import { Box, Typography, Grid } from "@mui/material";
import { ThemeProvider } from "@mui/material";
// Boton desplegable
import Button from "@mui/material/Button";
//CSV
import { ExportToCsv } from "export-to-csv";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { blueGrey } from "@mui/material/colors";

function Historial_conversion(props) {
  //CSV CONVERSION
  const [conversionCSV, setConversionCSV] = useState();

  const obtenerConversionCSV = () => {
    fetch(UrlApi + "/stock_transacciones/conversionCSV/" + props.sucursal)
      .then((data) => data.json())
      .then((data) => setConversionCSV(data));
  };

  //funcion que espera los cambios de la funcion
  useEffect(() => {
    obtenerConversionCSV();
  }, []);

  useEffect(() => {
    if (conversionCSV && conversionCSV.length > 0) {
      const conversionesOrdenadas = conversionCSV.sort(
        (a, b) => new Date(b.fecha_transaccion) - new Date(a.fecha_transaccion)
      );
      setConversionCSV([...conversionesOrdenadas]); // Actualiza el estado con el array ordenado
    }
  }, [conversionCSV]);

  //************************************************************************************************************************************************ */

  const columns9 = useMemo(
    // TABLA CONVERSION
    () => [
      {
        header: "Fecha",
        accessorKey: "fecha_transaccion",
        size: 60,
        type: "date",
        format: "YYYY-MM-DD HH:mm",
      },
      { header: "Artículo", accessorKey: "nombre_articulo", size: 110 },
      {
        header: "Almacén de Origen",
        accessorKey: "almacen_nombre_origen",
        size: 100,
      },
      {
        header: "Almacén de Destino",
        accessorKey: "almacen_nombre_destino",
        size: 100,
      },
      {
        header: "Convertido al Artículo",
        accessorKey: "nombre_convertible",
        size: 100,
        enableHiding: true,
      },
      {
        header: "Cantidad Convertida",
        accessorKey: "cantidad_enviada",
        size: 100,
        enableHiding: true,
      },
    ],
    []
  );

  const columnsConversionCSV = useMemo(
    // TABLA CONVERSION CSV
    () => [
      { header: "Artículo", accessorKey: "nombre_articulo", size: 110 },
      {
        header: "Almacén de Origen",
        accessorKey: "almacen_nombre_origen",
        size: 100,
      },
      {
        header: "Almacén de Destino",
        accessorKey: "almacen_nombre_destino",
        size: 100,
      },
      {
        header: "Cantidad Convertida",
        accessorKey: "cantidad_enviada",
        size: 100,
        enableHiding: true,
      },
      {
        header: "Convertido al Artículo",
        accessorKey: "nombre_convertible",
        size: 100,
        enableHiding: true,
      },
      {
        header: "Fecha",
        accessorKey: "fecha_transaccion",
        size: 60,
        type: "date",
        format: "YYYY-MM-DD HH:mm",
      },
      { header: "Usuario", accessorKey: "usuario", size: 75 },
    ],
    []
  );
  //************************************************************************************************************************************************ */
  //CSV CONVERSION
  const csvOptionsConversion = {
    fieldSeparator: ",",
    quoteStrings: '"',
    decimalSeparator: ".",
    showLabels: true,
    useBom: true,
    useKeysAsHeaders: false,
    filename: `Historial de Conversión de Artículos de la Sucursal ${props.nombreSuc}`,
    headers: columnsConversionCSV.map((c) => c.header),
  };
  const csvExporterConversion = new ExportToCsv(csvOptionsConversion);

  const handleExportDataConversion = () => {
    csvExporterConversion.generateCsv(conversionCSV);
  };

  return (
    <div>
      <Box mt={2} mb={4}>
        <ThemeProvider theme={props.tableTheme}>
          <MaterialReactTable
            enableExpandAll={false}
            enableToolbarInternalActions={true} //las acciones al lado del search (agregar y full screen)
            enableGrouping // para permitir agrupar x estado x ej
            layoutMode="grid"
            muiTableHeadCellProps={props.tableHeadCellProps}
            muiTableBodyCellProps={({ row }) => ({
              align: "left",
              sx: {
                color: "black",
                borderColor: "black",
              },
            })}
            enableColumnActions={true} //los puntitos de al lado de los titulos (acciones) -> hay que activarlo para agrupar x estado x ej
            enableColumnFilters={false} //desactiva filtros x  columna
            enableHiding={false} // opcion de ocultar columna pero activando el enablecolumaction
            enableDensityToggle={false} //
            localization={MRT_Localization_ES} //idioma
            enableColumnDragging={false} //para arrastrar columnas
            initialState={props.initialState}
            muiSearchTextFieldProps={props.muiSearchTextFieldProps}
            columns={columns9}
            data={props.conversion} //con lo q la completas (esto cambia siempre)
            enableStickyFooter
            // enableEditing
            positionActionsColumn="last" // posicion de la columna de acciones al final
            // ACCIONES
            renderToolbarInternalActions={(
              { table } // boton para nuevo , al lado del buscar
            ) => (
              <>
                <Grid item xs={6} ml={4}>
                  <Button
                    variant="contained"
                    color="primary"
                    endIcon={<FileDownloadIcon />}
                    onClick={handleExportDataConversion}
                    style={{
                      backgroundColor: blueGrey[700],
                      color: "white",
                    }}
                    size="small"
                  >
                    Exportar a CSV
                  </Button>
                </Grid>
                <MRT_FullScreenToggleButton table={table} />
              </>
            )}
            renderTopToolbarCustomActions={() => (
              <>
                <Typography variant="poster" fontSize={26}>
                  Conversión de Artículos
                </Typography>
              </>
            )}
          />
        </ThemeProvider>
      </Box>
    </div>
  );
}

export default Historial_conversion;
